import { useI18n } from 'vue-i18n';
import type { PubPartnersContentItem } from '@/types';
import { noDecimalsFilter, thousandsSeparatorFilter } from '../utils/filters';

export const usePubDetailsItemUtils = () => {
  const { t } = useI18n();

  const POUND_SIGN = '£';
  const PERCENTAGE_SIGN = '%';
  const FALLBACK_VALUE = t('important-information-default-value');

  const transformNum = (value: number | string) =>
    thousandsSeparatorFilter(noDecimalsFilter(value));

  const transformPercentage = (value: number | string) => value + PERCENTAGE_SIGN;

  const transformString = <T>(fieldText: T): T | string[] => {
    if (typeof fieldText == 'string' && fieldText.includes('\n')) {
      return fieldText.split('\n');
    }
    return fieldText;
  };

  const createContentItem = (
    key: string,
    val: unknown,
    transformNumber: boolean = true,
    isBolded: boolean = false,
    isPercentage: boolean = false
  ): PubPartnersContentItem => {
    let value: PubPartnersContentItem['value'] = FALLBACK_VALUE;
    let transformedValue: unknown = val;

    if (transformNumber && typeof val === 'number' && !Number.isNaN(val)) {
      transformedValue = POUND_SIGN + transformNum(val);
    } else if (isPercentage && val) {
      transformedValue = transformPercentage(val as number | string);
    } else {
      transformedValue = transformString(transformedValue);
    }

    if (
      transformedValue != null &&
      transformedValue !== '' &&
      (!Array.isArray(transformedValue) || transformedValue.length) &&
      (typeof transformedValue === 'string' ||
        typeof transformedValue === 'number' ||
        Array.isArray(transformedValue))
    ) {
      value = transformedValue;
    }

    return {
      label: t(`${key}`),
      value,
      isBolded,
    };
  };

  return { createContentItem, transformNum, transformPercentage, transformString, FALLBACK_VALUE };
};
